var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0991 88.3336C19.9835 85.2571 9.74264 75.0165 6.66611 61.901C4.4443 52.4287 4.4443 42.5715 6.66611 33.0993C9.74264 19.9837 19.9835 9.74288 33.0991 6.6664C42.5712 4.44454 52.4284 4.44454 61.9007 6.66635C75.0162 9.74288 85.2569 19.9836 88.3334 33.0993C90.5552 42.5715 90.5552 52.4287 88.3334 61.901C85.2569 75.0165 75.0162 85.2571 61.9007 88.3336C52.4284 90.5555 42.5712 90.5555 33.0991 88.3336Z",
    stroke: "#0095FF",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.099 88.3336C42.5711 90.5554 52.4283 90.5554 61.9006 88.3336C75.0162 85.2571 85.2568 75.0165 88.3333 61.901C90.5551 52.4286 90.5551 42.5715 88.3333 33.0993C85.2568 19.9836 75.0162 9.74288 61.9006 6.66639C52.4283 4.44454 42.5711 4.44454 33.099 6.66639C19.9833 9.74288 9.74255 19.9837 6.66602 33.0993",
    stroke: "#363853",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5137 46.3196L43.9581 55.764L60.4859 38.0557",
    stroke: "#0095FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.8308c694ca651d60428bc5a725f80ff0.svg";
export { ForwardRef as ReactComponent };